import Testing from "pages/Testing";

const AllRoutes: any = [
  { path: "/testing", name: "ForgotPassword", component: <Testing /> },
];

export default AllRoutes;
